import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Blade, Button, ProgressIndicator } from "rhombus-react";

import useActiveCreative from 'hooks/useActiveCreative';
import { closeModal } from 'reducers/Modal';
import { loadConcept, addExistingCreativesToConcept } from 'reducers/ConceptDetails';
import { loadCreatives } from 'reducers/Creatives';
import ExistingCreativesGrid from './ExistingCreativesGrid';

import './AddCreativesToConcept.css';

export default function AddCreativesToConcept(props){
	const { libraryId, conceptId, conceptName, creativeId } = props
		, dispatch = useDispatch()
		, onClose = () => dispatch(closeModal())
		, {
			conceptDetails,
			creatives,
			selectedCreativeIds,
		} = useSelector((state) => {
			return {
				conceptDetails: state.conceptDetails?.data,
				creatives: state.existingCreatives?.items || [],
				selectedCreativeIds:state.selected?.existingCreatives,
			};
		})
		, isUpdating = false
		, existingSizes = conceptDetails?.sizes
		, modalTitle = `Add Existing Creative - ${conceptName}`
		, onSubmit = () => {
			setIsLoading(true);
			dispatch(addExistingCreativesToConcept({ libraryId, conceptId, newConceptName: conceptName }))
				.then((response) => {
					setIsLoading(false);
					if (response?.success) {
						dispatch(loadCreatives(libraryId));
						return dispatch(closeModal());
					}
				});
		}
		, [isLoading, setIsLoading] = useState(false);

	useActiveCreative(creativeId);

	useEffect(() => {
		setIsLoading(true);
		dispatch(loadConcept(libraryId, conceptId)).then(resp => setIsLoading(false));
	}, []);

	const filterCreatives = () => {
		return existingSizes?.map((size) => {
			const { width, height } = size;
			return `${width} x ${height}`;
		});
	};

	const filterCreativeVals = useMemo(() => filterCreatives(), [creatives, existingSizes]);

	const renderContent = () => {
		return (
			<div className="add-creative-to-concept-modal-body">
				<ProgressIndicator isLoading={isLoading} />
				<ExistingCreativesGrid formattedExistingSizes={filterCreativeVals} libraryId={libraryId} />
			</div>
		);
	};


	const renderFooter = () => ([
		<Button key="cancel" theme="grey" disabled={isUpdating} onClick={onClose}>Cancel</Button>,
		<Button key="submit" theme="blue" disabled={!selectedCreativeIds?.length || isLoading || isUpdating} onClick={onSubmit}>
			Add Creatives to Concept
		</Button>
	]);

	return (
		<Blade
			type="modal"
			setAppTitle={false}
			className="add-existing-creatives-to-concept"
			title={modalTitle}
			allowFullScreen={false}
			xClose
			bladeProps={{ verticallyCenter: true }}
			onClose={onClose}
			renderContent={renderContent}
			renderFooter={renderFooter}
		/>
	);
}

AddCreativesToConcept.propTypes = {
	formattedExistingSizes: PropTypes.array,
	libraryId: PropTypes.number,
};
